import {
    IMAGE_LIGHTBOX_OPEN,
    IMAGE_LIGHTBOX_CLOSE,
} from '../constants';

export function openImageLightBox() {
    return async (dispatch) => {
        document.getElementById("customImageBoxModal").style.display = "block";
        document.body.classList.add('defaultScrollHidden');
        dispatch({
            type: IMAGE_LIGHTBOX_OPEN,
            imageLightBox: true
        });
        return true;
    };
}

export function closeImageLightBox() {
    return async (dispatch) => {
        document.getElementById("customImageBoxModal").style.display = "none";
        document.body.classList.remove('defaultScrollHidden');
        dispatch({
            type: IMAGE_LIGHTBOX_CLOSE,
            imageLightBox: false
        });
        return true;
    };
}

export function openExactImageLightBox(currentIndex) {
    document.getElementById("customImageBoxModal").style.display = "block";
    document.body.classList.add('defaultScrollHidden');
    return async (dispatch) => {
        dispatch({
            type: IMAGE_LIGHTBOX_OPEN,
            imageLightBox: true,
            currentIndex: currentIndex
        });

        return true;
    };
}

